import HoSoSurveyPage from "./HoSoSurveyPage"

export default HoSoSurveyPage 